export const formVisibilityHandler = () => {
  const formContainer = document.getElementsByClassName('EPiServerForms');

  if (formContainer.length) {
    Array.from(formContainer).forEach((_element, index) => {
      const currentForm = formContainer[index];
      const layout = currentForm.parentElement;
      const inputName = 'backgroundClass';

      const container = layout.parentElement;
      container.classList.add('section-container');
      currentForm.classList.add('is-loaded');

      if (currentForm.elements[inputName] && currentForm.elements[inputName].value) {
        const backgroundClass = currentForm.elements[inputName].value;
        container.classList.add(backgroundClass);
      }
    });
  }
};
